<script setup>
import { computed, onMounted } from 'vue';

import AgentTable from './overview/AgentTable.vue';
import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';

const store = useStore();

const uiFlags = useMapGetter('getOverviewUIFlags');
const agentConversationMetric = useMapGetter('getAgentConversationMetric');
const agents = useMapGetter('agents/getAgents');

const totalOpen = computed(() => {
  return (agentConversationMetric.value || []).reduce(
    (sum, m) => sum + (m.open || 0),
    0
  );
});

const totalUnattended = computed(() => {
  return (agentConversationMetric.value || []).reduce(
    (sum, m) => sum + (m.unattended || 0),
    0
  );
});

const fetchData = () => store.dispatch('fetchAgentConversationMetric');

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  store.dispatch('agents/get');
  fetchData();
  startRefetching();
});
</script>

<template>
  <div class="flex flex-row flex-wrap max-w-full">
    <MetricCard :header="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.HEADER')">
      <!-- Badges de Consolidado en el Header -->
      <template #control>
        <div
          v-if="agents.length && !uiFlags.isFetchingAgentConversationMetric"
          class="flex items-center gap-2 flex-wrap"
        >
          <div class="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-n-alpha-1 border border-n-container text-xs">
            <span class="size-2 rounded-full bg-blue-500 flex-shrink-0" />
            <span class="text-n-slate-11 font-medium">
              {{ $t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.TOTAL_OPEN') }}:
            </span>
            <span class="font-bold text-n-slate-12 text-sm">
              {{ totalOpen }}
            </span>
          </div>
          <div class="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-n-alpha-1 border border-n-container text-xs">
            <span class="size-2 rounded-full bg-amber-500 flex-shrink-0" />
            <span class="text-n-slate-11 font-medium">
              {{ $t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.TOTAL_UNATTENDED') }}:
            </span>
            <span class="font-bold text-n-slate-12 text-sm">
              {{ totalUnattended }}
            </span>
          </div>
        </div>
      </template>

      <!-- Tabla a Ancho Completo -->
      <div class="flex flex-col w-full">
        <AgentTable
          :agents="agents"
          :agent-metrics="agentConversationMetric"
          :is-loading="uiFlags.isFetchingAgentConversationMetric"
          :total-open="totalOpen"
          :total-unattended="totalUnattended"
        />
      </div>
    </MetricCard>
  </div>
</template>
